/** @ignore */
export function prettyPrint(val: any): string {
  return JSON.stringify(val, null, "  ");
}
